export default __webpack_public_path__ + "static/media/Newsletter 025.ac8984f6.png";